var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteModalIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 58,
    r: 58,
    fill: "#DB4437"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.615 70.2792H79.7375V76.4189H67.615V70.2792ZM67.615 45.7207H88.8294V51.8603H67.615V45.7207ZM67.615 58H85.7988V64.1396H67.615V58ZM31.2474 76.4189C31.2474 79.7957 33.975 82.5585 37.3087 82.5585H55.4925C58.8262 82.5585 61.5537 79.7957 61.5537 76.4189V45.7207H31.2474V76.4189ZM64.5844 36.5112H55.4925L52.4618 33.4414H40.3393L37.3087 36.5112H28.2168V42.6509H64.5844V36.5112Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteModalIcon);
export default __webpack_public_path__ + "static/media/DeleteModalIcon.1defeea3d1f1698e7c5c342635330ca0.svg";
export { ForwardRef as ReactComponent };